import { post, get, deletefn, putfun } from './http.js'
export default {
  /* 列表 */
  async list(params) {
    return await get('/design-competition', params)
  },
  /* 详情 */
  async detail(params) {
    return await get(`/design-competition/${params}`)
  },
  /* 报名 */
  async sing(data) {
    return await post(`/design-competition-entry/${data.id}`, data)
  },
  /**作品列表 */
  async works(id, params) {
    return await get(`/design-competition-entry/${id}`, params)
  },
  /*大赛作品详情 */
  async workDetail(id, params) {
    return await get(`/competition-entry/${id}`, params)
  },
  //评论列表
  async commentList(params) {
    return await get(`/design-competition-reply/`, params);
  },
  /*评论 */
  async competitionComment(id, params) {
    return await post(`/design-competition-reply/${id}`, params)
  },
  //删除评论
  async deleteReply(id) {
    return await deletefn(`/design-competition-reply/${id}`)
  },
  //我的设计作品-列表
  async myWorks(params) {
    return await get(`/user/competition-entry/`, params)
  },
  //我的设计作品-详情
  async userWorkDetail(id) {
    return await get(`/user/competition-entry/${id}`)
  },
  //编辑大赛作品
  async editWork(id, params) {
    return await putfun(`/user/competition-entry/${id}`, params)
  },
  //上传作品
  async entry(id, params) {
    return await post(`/competition-upload-entry/${id}`, params)
  },
  //获取视频的帧数
  async resourceSnapshot(params) {
    return await get(`/common/resource-snapshot`, params)
  },
  //生成活动订单
  async buy(id, params) {
    return await post(`/design-competition-buy/${id}`, params)
  },
  //我的游学订单
  async myYxdd(params){
    return await get(`/user/design-orders`, params)
  },
  async yxddCancel(params){
    return await post(`user/design-order-cancel`,params)
  }
}




// WEBPACK FOOTER //
// ./src/request/active.js